import { gql } from '@apollo/client'

import { fragments } from './fragments'

export default gql`
    query salesOrderLines(
        $orderId: String!
        $statusNotIn: [String!]
        $limit: Int!
        $offset: Int!
        $cursor: ENCODED_CURSOR
        $isImMaafcoEnabled: Boolean = false
    ) {
        salesOrderLines(
            orderId: $orderId
            statusNotIn: $statusNotIn
            limit: $limit
            offset: $offset
            cursor: $cursor
        ) {
            cursor {
                previous
                next
            }
            totalCount
            productCount
            items {
                id
                producedBy
                deliveryStatus
                moldStatus
                erpMoldId
                quantity
                orderedQuantity
                deliveredQuantity
                erpProductToolId
                associatedParts @include(if: $isImMaafcoEnabled)
                material {
                    id
                    name
                    color
                    shore
                    materialGrade
                    colorCode
                    publicName
                }
                unitPrice
                productionRegion
                revision {
                    ...revision
                }
                dfmFeedback {
                    ...dfmFeedbackOrderDetailsPage
                }
                holes {
                    ...holes
                }
                processName
                processNames
                processes {
                    id
                    platformProcessId
                    processName
                    processNotes
                    color
                    thickness
                    texture
                    finish
                    toolLife
                    surfaceFinishCode
                    additionalSpecifications {
                        color
                        texture
                        thickness
                    }
                    dfmNotes {
                        color
                        process
                        texture
                        thickness
                    }
                }
                inspectionStatus
                productionStatus
                quoteModelRevisionAttachment {
                    id
                    fileName
                    downloadUrl
                    sanitized {
                        id
                        fileName
                        downloadUrl
                    }
                    annotated {
                        id
                        fileName
                        downloadUrl
                    }
                }
                shipmentAndInspection {
                    shipmentId
                    inspectionDocuments {
                        ...inspectionDocuments
                    }
                    woAvailableToShow
                    inspectionTypes
                }
                quoteModelRevision {
                    id
                    quoteModel {
                        quote {
                            id
                            type
                            name
                            isCpqOwned
                            user {
                                id
                                firstName
                                lastName
                                email
                            }
                        }
                    }
                    dfmReports {
                        quoteAttachmentRevisionId
                        asset {
                            id
                            createdAt
                            downloadUrl
                            fileName
                        }
                        source
                        uploaderEmail
                        source
                        isPublished
                    }
                    modelConfiguration {
                        fdmInfillPercentageCategoryLabel
                        color {
                            name
                        }
                        colorCode
                        process {
                            id
                        }
                    }
                }
            }
            parts {
                id
                producedBy
                deliveryStatus
                quantity
                orderedQuantity
                associatedErpProductToolId
                material {
                    id
                    name
                    color
                    shore
                    materialGrade
                    colorCode
                }
                unitPrice
                productionRegion
                revision {
                    ...revision
                }
                dfmFeedback {
                    ...dfmFeedbackOrderDetailsPage
                }
                holes {
                    ...holes
                }
                processName
                processNames
                processes {
                    id
                    platformProcessId
                    processName
                    processNotes
                    color
                    thickness
                    texture
                    finish
                    toolLife
                    surfaceFinishCode
                    additionalSpecifications {
                        color
                        texture
                        thickness
                    }
                    dfmNotes {
                        color
                        process
                        texture
                        thickness
                    }
                }
                inspectionStatus
                productionStatus
                quoteModelRevisionAttachment {
                    id
                    fileName
                    downloadUrl
                    sanitized {
                        id
                        fileName
                        downloadUrl
                    }
                    annotated {
                        id
                        fileName
                        downloadUrl
                    }
                }
                quoteModelRevision {
                    id
                    quoteModel {
                        quote {
                            id
                            type
                            name
                            user {
                                id
                                firstName
                                lastName
                                email
                            }
                        }
                    }
                    dfmReports {
                        quoteAttachmentRevisionId
                        asset {
                            id
                            createdAt
                            downloadUrl
                            fileName
                        }
                        source
                        uploaderEmail
                        source
                        isPublished
                    }
                    modelConfiguration {
                        fdmInfillPercentageCategoryLabel
                        color {
                            name
                        }
                        colorCode
                        process {
                            id
                        }
                    }
                }
                shipmentAndInspection {
                    shipmentId
                    inspectionDocuments {
                        ...inspectionDocuments
                    }
                    woAvailableToShow
                    inspectionTypes
                }
            }
        }
    }
    ${fragments.Revision}
    ${fragments.DfmFeedback}
    ${fragments.Holes}
    ${fragments.InspectionDocuments}
`
